import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class VersaoSistemaService extends BaseService {
  constructor() {
    super(`${ConfigApi.versaoSistemaURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.id = undefined;
    this.versao = '';
    this.idSistema = undefined;

    this.limit = 11;
    this.page = 0;
  }
}
export default new VersaoSistemaService();
